/*
 * нормализация нужна для преобразования такого
 * '/properties/_reason/allOf/0/then/properties/reason_replacement'
 * в такое
 * '/_reason/reason_replacement'
 * для сопоставления со структурой из ui_schema
 * (там обычная вложенность объектов, без properties, allOf и прочего)
 */

export const normalizeSchemaPointer = (str: string) =>
  str.replaceAll(/\/allOf\/\d+\/(if|then)/g, '').replaceAll('/properties', '');
